import _ from "lodash"
export type ClampOpts = {
  min: number,
  max: number
}

export const clamp = (opts: ClampOpts) => (v: number) => _.clamp(v, opts.min, opts.max)
